import { Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Autocomplete, TextField, Box } from '@mui/material'
import MainCard from 'components/MainCard'
import React, { useState } from 'react'

function PoseDetectionError() {
    const [selectedPlan, setSelectedPlan] = useState(null);
   
    const allCoaches = [
        {
            poseId: 1,
            coachName: 'Coach - 1',
            error: 'Landmark Missing',
            pose: 'pose-10',
            
        },
        {
             poseId: 2,
            coachName: 'Coach - 2',
            error: 'Error while opening the camera',
            pose: 'pose-15',
        },
        {
             poseId: 3,
            coachName: 'Coach - 3',
            error: 'Landmark Missing',
            pose: 'pose-26',
        },
        {
             poseId: 4,
            coachName: 'Coach - 4',
            error: 'Error while storing in database',
            pose: 'pose-5',
        },
       
    ];
    const filteredCoaches = selectedPlan
        ? allCoaches.filter((coach) => coach.plan === selectedPlan)
        : allCoaches;
  return (
    <MainCard>
      {/* <Box sx={{ mb: 2, maxWidth: 300 }}>
        <Autocomplete
          options={planOptions}
          value={selectedPlan}
          onChange={(event, newValue) => setSelectedPlan(newValue)}
          renderInput={(params) => <TextField {...params} label="Filter by Plan" variant="outlined" />}
          clearOnEscape
          isOptionEqualToValue={(option, value) => option === value}
        />
      </Box> */}
      <TableContainer component={Paper}>
                <Table sx={{ minWidth: 800 }} aria-label="coach table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell>Coach Name</TableCell>
                      <TableCell>Error</TableCell>
                      <TableCell>Pose Name</TableCell>                      
                    </TableRow>
                  </TableHead>
                 <TableBody>
                    {filteredCoaches.length > 0 ? (
                      filteredCoaches.map((coach, index) => (
                        <TableRow key={coach.poseId}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>
                            {coach.coachName
                              .toLowerCase()
                              .split(' ')
                              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                              .join(' ')}
                          </TableCell>
                        <TableCell>{coach.error}</TableCell>
                          <TableCell>{coach.pose}</TableCell>
                             
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <Lottie options={loaderOptions} height="25%" width="25%" />
                          <Box sx={{ mt: 2 }}>No coaches found matching your criteria.</Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody> 
                </Table>
              </TableContainer>
    </MainCard>
  )
}

export default PoseDetectionError;